import {Coupon} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {useMemo} from 'react';

export const useGetHighestCouponDiscountValue = ({
  coupons,
  activatedCouponDiscountValue = 0,
}: {
  coupons: Coupon[];
  activatedCouponDiscountValue?: number;
}) => {
  return useMemo(
    () =>
      coupons.reduce((discountValue, coupon) => {
        switch (coupon.type?.$case) {
          case 'simpleCoupon':
            return Math.max(
              discountValue,
              Math.abs(+coupon.type.simpleCoupon.discountValue.value),
            );
          case 'hotDealCoupon':
            return Math.max(
              discountValue,
              Math.abs(+coupon.type.hotDealCoupon.discountValue.value),
            );
          case 'minimumOrderValueCoupon': {
            const movCouponDiscountValues = [
              ...coupon.type.minimumOrderValueCoupon.tiers.map(movCoupon =>
                Math.abs(+movCoupon.discountValue.value),
              ),
            ];
            return Math.max(...[discountValue, ...movCouponDiscountValues]);
          }
          case 'highTierCoupon': {
            if (coupon.type.highTierCoupon.discount?.$case === 'tiers') {
              const highTierCouponDiscountValues =
                coupon.type.highTierCoupon.discount.tiers.tiers.map(movCoupon =>
                  Math.abs(+movCoupon.discountValue.value),
                );

              return Math.max(
                ...[discountValue, ...highTierCouponDiscountValues],
              );
            } else {
              const relativeDiscount =
                coupon.type.highTierCoupon.discount?.relativeDiscount.value ||
                0;
              return Math.max(discountValue, Math.abs(+relativeDiscount));
            }
          }
          default:
            return 0;
        }
      }, activatedCouponDiscountValue),
    [activatedCouponDiscountValue, coupons],
  );
};
